import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { TechSpecsSection } from "@swo/storefront";
import React from "react";
import { css } from "@emotion/react";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import { CSS_MQ } from "../../../styles/breakpoints";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { readonlyArray, string } from "fp-ts";
import { T } from "../../../components/T";

export const ComparisonSections: ReactTFC<TechSpecsSection> = props => {
  function getSections() {
    switch (props.tag) {
      case "reticle": {
        return props.attributes.map(reticle => {
          return {
            value: (
              <div
                css={[
                  FONTS.SwarovskiFutura300,
                  css`
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  `,
                ]}
              >
                <img
                  src={reticle.url}
                  css={css`
                    margin-bottom: 10px;

                    ${CSS_MQ.atMostSm} {
                      max-width: 100%;
                      max-height: 100%;
                    }

                    ${CSS_MQ.atLeastMd} {
                      max-width: 100%;
                      max-height: 200px;
                    }
                  `}
                />
                <span css={fontSize.x2s}>
                  <T>{reticle.label}</T>
                </span>
              </div>
            ),
            label: undefined,
          };
        });
      }

      case "color": {
        return props.attributes.map(color => {
          return {
            value: (
              <span
                css={css`
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  display: inline-block;
                `}
                style={{
                  backgroundColor: color.hex,
                }}
              />
            ),
            label: color.label,
          };
        });
      }

      case "plain": {
        return props.attributes.map(attribute => {
          return {
            value: "",
            label: attribute.label,
          };
        });
      }

      case "list": {
        return props.attributes.map((attr, idx) => {
          return {
            value: !attr.values.length ? (
              <span css={styles} className={"empty"}>
                —
              </span>
            ) : (
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                `}
              >
                {roaUniqString(attr.values.map(v => (typeof v === "string" ? v : v.value))).map(a => (
                  <span key={a} css={styles}>
                    {a}
                  </span>
                ))}
              </div>
            ),
            label: attr.label || undefined,
          };
        });
      }

      default: {
        const _: never = props;
        return _;
      }
    }
  }

  const sections = getSections();

  return (
    <div
      css={css`
        display: grid;
        gap: 12px 15px;
        width: 100%;

        ${CSS_MQ.atLeastMd} {
          --m: calc(var(--w) + var(--g));

          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 20px 30px;
          margin-left: var(--m);
          max-width: calc(800px - var(--m));
        }
      `}
    >
      {sections.map((section, idx) => {
        return (
          <div
            key={idx}
            css={css`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: flex-end;
            `}
          >
            <div>
              <div css={[FONTS.SwarovskiFutura300, fontSize.x25]}>{section.value}</div>

              {section.label && (
                <span
                  css={[
                    FONTS.SwarovskiFutura300,
                    fontSize.x2s,
                    fontColor.grey,
                    css`
                      display: flex;
                    `,
                  ]}
                >
                  <T>{section.label}</T>
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const roaUniqString = readonlyArray.uniq(string.Eq);

const styles = css`
  .highlighted > &:not(.empty) {
    color: ${CSS_COLORS.Green};
  }
`;
